// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"ql_a bhn_sw bhn_kx bhn_ky","PostDetailRight__brandDaysPosts":"ql_b bhn_sw bhn_kx bhn_ky"};